<template>
  <div>
    <v-row>
      <v-col cols="6">
        <div class="font-weight-normal text-h4 d-none d-sm-inline">
          {{
            $t('main.hello', {
              username: authUser.NOMECOMPLETO || authUser.NOME,
            })
          }}
          <br />
          {{ $t('main.welcome') }}
          <span class="text-h4 font-weight-bold black--text">
            Gestao<span class="font-weight-bold texto-vermelho-escuro"
              >WEB</span
            ></span
          >
        </div>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-divider class="my-4"/>
        <quick-access-list />

       
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState('authModule', ['authUser']),
  },
  components:{
    QuickAccessList: () => import('@/components/unique/home/QuickAccessList'),
  },
  methods: {
    redirectToPDV() {
      this.$router.push({ name: 'PDV' })
    },
  },
}
</script>

<style></style>
